import { useState } from 'react';
import { Icon, P, Button } from '@workramp/ui';
import WRModalsConfirm from '~/components/wr-modals/wr-modals-confirm';

interface UploadedFontFileProps {
  customFontFile: string;
  removeCallback: () => void;
}

const MODAL_DESCRIPTION = 'Upon removal of your custom font, the site will display the previously used font.';
const MODAL_TEXT = 'Are you sure you want to remove this font?';

export default function UploadedFontFile({ customFontFile, removeCallback }: UploadedFontFileProps) {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <WRModalsConfirm
        onSave={removeCallback}
        onClose={() => setShowModal(false)}
        show={showModal}
        text={MODAL_TEXT}
        cancelButtonTitle="Cancel"
        saveButtonTitle="Delete"
        newUi
        isDangerConfirm
        description={MODAL_DESCRIPTION}
      />
      <P size={1}>
        {customFontFile}
        <Button variant="text" onPress={() => setShowModal(true)}>
          <Icon color="#8998ac" name="trash:regular" size="md" />
        </Button>
      </P>
    </>
  );
}
